import React from 'react';
import { observer } from 'mobx-react';
import { DropDownMenu } from '@/shared/menu/dropDownMenu';
import { StyledPrimaryNavigation } from '@/shared/menu/styledPrimaryNavigation';
import { CompatibilitySelector } from '@/shared/navigation';
import { primaryNavigationMenuItem, Desktop, Mobile } from './menu.sc';

export const Menu = observer(() => {
  return (
    <React.Fragment>
      <Desktop data-test-automation-id="menu" role="navigation">
        <StyledPrimaryNavigation
          cssProp={{
            menuItem: primaryNavigationMenuItem,
          }}
        />
        <CompatibilitySelector />
      </Desktop>
      <Mobile data-test-automation-id="menu">
        <DropDownMenu />
      </Mobile>
    </React.Fragment>
  );
});
